import React from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import { withStyles } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { compose } from "recompose";

const styles = {
  card: {
    maxWidth: 400,
    minWidth: 250
  },
  actionRoot: {
    padding: "8px 8px 8px 16px",
    backgroundColor: "#C3DEDC"
  },
  icons: {
    marginLeft: "auto"
  },
  typography: {
    color: "#419081",
    paddingLeft: "4px",
    fontWeight: 600
  }
};
const CustomSnackbarRenderer = props => {
  const handleDismiss = () => {
    props.closeSnackbar(props.id);
  };
  const { classes } = props;
  return (
    <Card className={classes.card}>
      <CardActions classes={{ root: classes.actionRoot }}>
        {props.animation}
        <Typography variant="subtitle2" className={classes.typography}>
          {props.snackbarLabel}
        </Typography>
        <div className={classes.icons}>
          <IconButton
            aria-label="cancel"
            onClick={handleDismiss}
          >
            <CancelIcon />
          </IconButton>
        </div>
      </CardActions>
    </Card>
  );
};

export default compose(
  withStyles(styles),
  withSnackbar
)(CustomSnackbarRenderer);
